// Module
var code = "<div class=\"widget-content relative\" style=\"flex-direction:column;display:flex\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <div class=\"task-progress\"> </div> </div>";
// Exports
module.exports = code;